function divideChunks(list, chunkLength){
    return Array.from(
        new Array(Math.ceil(list.length / chunkLength)),
        (_, i) => list.slice(i * chunkLength, i * chunkLength + chunkLength)
    );
}

export {
    divideChunks
}